import { Link, LinkProps } from '@opendoor/bricks/core';
import { SystemStyleObject } from '@opendoor/bricks/system/utils';
import { useObservability } from '../../../helpers/observability';
import NextLink, { LinkProps as NextLinkProps } from 'next/link';

// const RouterLink = bricks(NextLink);
export type NavLinkProps = Omit<LinkProps, 'href' | 'onClick' | 'variant' | 'analyticsName'> & {
  active?: boolean;
  href: NextLinkProps['href'];
  analyticsName: LinkProps['analyticsName'];
  /** @deprecated */
  deprecatedTrackingEvent?: Parameters<ReturnType<typeof useObservability>['trackEvent']>;
};

export const getNavLinkStyles = (active?: boolean): SystemStyleObject => ({
  fontSize: 's0',
  lineHeight: 's1',
  color: active ? 'brand50' : 'neutrals100',
  textDecoration: active ? 'underline' : 'none',
  fontWeight: 'semibold',
  _hover: { color: 'brand50', textDecoration: 'underline', backgroundColor: 'transparent' },
  _active: { color: 'brand50', textDecoration: 'underline', backgroundColor: 'transparent' },
});

export const NavLink: React.FC<NavLinkProps> = ({
  active,
  href,
  deprecatedTrackingEvent,
  ...props
}) => {
  const { trackEvent } = useObservability();
  const isExternalLink =
    typeof href === 'string' &&
    (href?.startsWith('https:') || href?.startsWith('tel:') || href?.startsWith('https:'));

  const handleClick = () => deprecatedTrackingEvent && trackEvent(...deprecatedTrackingEvent);

  if (isExternalLink) {
    return (
      <Link
        variant="inline-secondary"
        href={href as string}
        sx={getNavLinkStyles(active)}
        onClick={handleClick}
        {...props}
      />
    );
  }

  return (
    <NextLink passHref href={href}>
      <Link
        variant="inline-secondary"
        sx={getNavLinkStyles(active)}
        onClick={handleClick}
        {...props}
      />
    </NextLink>
  );
};
